var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative",
      background: "#fff"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", {
    staticClass: "disclosureIcp"
  }, [_vm.styleObj.controlsDisclosurePageDisplay ? _c("span", [_vm._v(_vm._s(_vm.$t("披露页名称")))]) : _vm._e(), _vm.styleObj.controlsDisclosurePageDisplay && _vm.styleObj.controlsICPDisplay ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.styleObj.controlsICPDisplay ? _c("span", [_vm._v(_vm._s(_vm.$t("icp备案号")))]) : _vm._e()]), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };